import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initSentry } from './config/sentry';
import { AdminAuthProvider } from './hooks/useAdminAuth';
import AdminApp from './AdminApp';
import './index.css';
import './dark-mode.css';

initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5 * 60 * 1000, retry: 1, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ErrorBoundary>
        <AdminAuthProvider>
          <AdminApp />
        </AdminAuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </QueryClientProvider>
);
